import { Resi } from "@base/resi/Resi";
import { IdGen } from "@base/util/IdGen";
import { ILoadingModel } from "@viz/slices/LoadingSlice.types";
import { VizFacade } from "@viz/VizFacade";

const slice = Resi.createSliceWithStore("LoadingModel", {
  hot: import.meta.hot || import.meta.webpackHot,
  init: () => {
    const ret: ILoadingModel = {
      items: [],
    };
    return ret;
  },
  reducers: {
    push: (old: ILoadingModel, id: string, title: string | React.ReactNode, backgroundColor?: string): ILoadingModel => {
      return {
        ...old,
        items: [...old.items, { id, title, backgroundColor }],
      };
    },
    remove: (old: ILoadingModel, id: string): ILoadingModel => {
      return {
        ...old,
        items: old.items.filter((o) => o.id !== id),
      };
    },
  },
});

export const loadingSlice = {
  ...slice,
  util: {
    pushItem(title: string | React.ReactNode, backgroundColor?: string) {
      const id = IdGen.unsecure.get();
      slice.dispatcher.push(id, title, backgroundColor);
      const frameLoopDone = VizFacade.pushFrameLoop("demand");
      return () => { frameLoopDone(); slice.dispatcher.remove(id) };
    },
    push(title: string | React.ReactNode, options?: { delay?: number; backgroundColor?: string }) {
      const delay = options?.delay === undefined ? 0 : options.delay;
      if (delay === 0) return this.pushItem(title, options?.backgroundColor);

      let hideLoading: (() => void) | undefined;
      const loadingTimeout = setTimeout(() => {
        hideLoading = this.pushItem(title, options?.backgroundColor);
      }, delay);

      return () => {
        clearTimeout(loadingTimeout);
        if (hideLoading) hideLoading();
      };
    },
    // async do<R>(title: string, fn: () => Promise<R>, options?: { delay?: number; backgroundColor?: string, errorMsg?: string }) {
    //   const done = this.push(title, options)
    //   try {
    //     return await fn();
    //   } catch (e) {
    //     overlaySlice.util.showError(options?.errorMsg || _getLocaContext().C("Error_Action_Failed"));
    //   } finally {
    //     done();
    //   }
    //   return undefined;
    // }
  },
};